<template>
  <div>
    <Form
      page-title="Edit Category"
      buttonName="Update"
      :isInList="isInList"
      :businessId="businessId"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateCategory } from "@/API/CategoriesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "showAdd", "businessId"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateCategory(formData), callback);
    }
  }
};
</script>
<style></style>
